import { render } from "./Team.vue?vue&type=template&id=2922ab42"
import script from "./Team.vue?vue&type=script&lang=ts"
export * from "./Team.vue?vue&type=script&lang=ts"

import "./Team.vue?vue&type=style&index=0&id=2922ab42&rel=stylesheet&lang=scss"
script.render = render

export default script